export default "__VITE_ASSET__BjAoo49h__"